var e=document.createElement('div');
e.id='ghjjghf6757tg86';
e.style.display='none';
document.body.appendChild(e);